export default __webpack_public_path__ + "static/media/StaticPage4.eae9579e.txt";